import { Icon } from '@mui/material';
import { Styled } from './index.styles';
import { ReactElement, ReactNode } from 'react';

interface PropsModel {
    children: ReactNode;
    element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
    color?: 'primary' | 'secondary';
    size?: 'large' | 'middle' | 'small';
    weight?: 'default' | 'thin' | 'normal' | 'bold';
    align?: 'left' | 'center' | 'right';
    highlighted?: boolean;
    icon?: ReactElement;
    className?: string;
}
const Title = (props: PropsModel) => {
    const {
        element = 'h1',
        color = 'primary',
        align = 'center',
        size = 'middle',
        weight = 'normal',
        highlighted = true,
        icon,
        className = '',
    } = props;
    const CustomElement = element as keyof JSX.IntrinsicElements;
    return (
        <Styled>
            <div
                className={`custom-title ${
                    highlighted && 'highlighted'
                } color-${color} size-${size} weight-${weight} align-${align} ${className}`}
            >
                {icon && (
                    <div className="icon">
                        <Icon>{icon}</Icon>
                    </div>
                )}
                <CustomElement className="custom-text">{props.children}</CustomElement>
            </div>
        </Styled>
    );
};

export default Title;
